import { Icon } from '@dixa/lib-shared-habla';
import { Toolbar, ToolbarButton } from 'articleEditor/components/toolbar';
import toolbarStyles from 'articleEditor/components/toolbar/toolbarButton.module.scss';
import { useFloatingLinkEdit } from 'lib-knowledge-document-structure';
import { LinkOpenButton } from 'lib-knowledge-document-structure/plate/link';

type UrlLinkDetailsProps = {
  editButtonProps: ReturnType<typeof useFloatingLinkEdit>['editButtonProps'];
  unlinkButtonProps: ReturnType<
    typeof useFloatingLinkEdit
  >['unlinkButtonProps'];
};

export const UrlLinkDetails = ({
  editButtonProps,
  unlinkButtonProps,
}: UrlLinkDetailsProps): JSX.Element => {
  return (
    <Toolbar>
      <ToolbarButton {...editButtonProps} isActive={false}>
        Edit Link
      </ToolbarButton>

      <LinkOpenButton
        className={toolbarStyles['toolbarButton']}
        rel="noopener noreferrer"
      >
        <Icon
          className={toolbarStyles['toolbarButtonIcon']}
          name="external-link"
        />
      </LinkOpenButton>

      <ToolbarButton
        icon="link-slash"
        {...unlinkButtonProps}
        isActive={false}
      />
    </Toolbar>
  );
};
